// extracted by mini-css-extract-plugin
export default {"root":"Main-root-ee4df41be5890ed4a7fdbd78d281d5eb"};